/**
 * @module FE-CU42_緊急連絡先設定画面
 */
import Header from '../../components/header/Header.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import EmergencyContactPage from './emergencyContactPage/EmergencyContactPage.vue';
import EmergencyContactFamilyMembersPage from './emergencyContactFamilyMembersPage/EmergencyContactFamilyMembersPage.vue';
import EmergencyContactFirstAidInfoPage from './emergencyContactFirstAidInfoPage/EmergencyContactFirstAidInfoPage.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU42';

export default {
  name: 'EmergencyContactSetting',
  components: {
    Header,
    ListPanel,
    EmergencyContactPage,
    EmergencyContactFamilyMembersPage,
    EmergencyContactFirstAidInfoPage,
    MobileFooter,
    BreadCrumbList,
    PcPageTitle,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU42緊急連絡先設定画面.緊急連絡先設定'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.C0001'),
      id: '',
      text: '',
      src: '',
      name: '',
      nameKana: '',
      relationship: '',
      phoneNumber: '',
      panelAreaTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      panelCameraTitle: {
        place: '',
        type: '',
        typeIsBefore: false,
      },
      panelTitle: '',
      displayAreaList: [],
      displayCameraList: [],
      currentTab: 0,
      tabNumber: 0,
      tabs: [
        {
          id: CONSTANTS.TAB_TYPE.EMERGENCY_CONTACT,
          tabName: vm.$vuetify.lang.t('$vuetify.FECU42緊急連絡先設定画面.緊急連絡先'),
        },
        {
          id: CONSTANTS.TAB_TYPE.FAMILY_MEMBERS_INFORMATION,
          tabName: vm.$vuetify.lang.t('$vuetify.FECU42緊急連絡先設定画面.同居家族情報'),
        },
        {
          id: CONSTANTS.TAB_TYPE.FIRST_AID_INFORMATION,
          tabName: vm.$vuetify.lang.t('$vuetify.FECU42緊急連絡先設定画面.救急情報'),
        },
      ],
      isEditing: false,
      width: 0,
      pageLeaveConfirmFunction: null,
    };
  },
  computed: {
    tabStyle: () => (currentTab, index) => {
      return {
        active: currentTab === index,
        'top-right-radius': currentTab === 0,
        'top-radius': currentTab === 1,
        'top-left-radius': currentTab === 2,
      };
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU42緊急連絡先設定画面.緊急連絡先設定'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.C0001'),
        panelAreaTitle: {
          place: vm.$vuetify.lang.t(
            '$vuetify.FECU42緊急連絡先設定画面.対象地区詳細表示領域.対象地区',
            this.panelTitle
          ),
          type: '',
          typeIsBefore: true,
        }, //"対象地区 - 自宅",
        panelCameraTitle: {
          place: vm.$vuetify.lang.t(
            '$vuetify.FECU42緊急連絡先設定画面.カメラ詳細表示領域.カメラ',
            this.panelTitle
          ),
          type: '',
          typeIsBefore: true,
        }, // "カメラ - リビングカメラ",
        tabs: [
          {
            id: CONSTANTS.TAB_TYPE.EMERGENCY_CONTACT,
            tabName: vm.$vuetify.lang.t('$vuetify.FECU42緊急連絡先設定画面.緊急連絡先'),
          },
          {
            id: CONSTANTS.TAB_TYPE.FAMILY_MEMBERS_INFORMATION,
            tabName: vm.$vuetify.lang.t('$vuetify.FECU42緊急連絡先設定画面.同居家族情報'),
          },
          {
            id: CONSTANTS.TAB_TYPE.FIRST_AID_INFORMATION,
            tabName: vm.$vuetify.lang.t('$vuetify.FECU42緊急連絡先設定画面.救急情報'),
          },
        ],
      };
    },
    currentDisplayType() {
      return this.$store.state.currentDisplayType;
    },
  },
  watch: {
    tabNumber(newVal) {
      this.$store.state.emergencyContactNumber = newVal;
    },
    isEditing(newVal) {
      newVal ? (this.pageLeaveConfirmFunction = this.confirmPageLeave) : null;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.tabNumber = this.$store.state.emergencyContactNumber;

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    // 遷移元からtabIndexのパラメータを受け取った場合にタブを切り替える
    if (this.$route.params.tabIndex) {
      this.currentTab = this.$route.params.tabIndex;
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isEditing && this.$store.getters['isLoggedIn'] && !(await this.confirmPageLeave())) {
      return;
    } else {
      next();
    }
  },
  /** @type {Methods} */
  methods: {
    /**
     * 緊急連絡先データ取得処理
     * @param {} payload 緊急連絡先データ
     */
    getPanelData(payload) {
      this.displayAreaList = payload.displayItems;
      this.panelAreaTitle = payload.title;
      this.panelTitle = payload.title.place;
    },
    /**
     * 緊急連絡先タブを非活性又は活性させる処理
     * @param {} nextState 緊急連絡先タブの非活性の有無
     */
    setIsEditing(nextState) {
      this.isEditing = nextState;
    },
    /**
     * 並べ替え中に画面遷移しようとした場合、確認ダイアログを表示する処理
     */
    async confirmPageLeave() {
      return await this.$agreementDialog(
        this.$vuetify.lang.t('$vuetify.FECU43緊急連絡先設定画面同居家族情報.確認'),
        this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU42緊急連絡先設定画面.C0007'),
        this.$vuetify.lang.t('$vuetify.FECU43緊急連絡先設定画面同居家族情報.いいえボタン'),
        this.$vuetify.lang.t('$vuetify.FECU43緊急連絡先設定画面同居家族情報.はいボタン')
      );
    },
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
};
